import React from "react"
import classNames from "classnames"

import { Idea } from "../../../../model/types"
import IdeaBox from "../../../components/idea_box"
import { previewFromHtml } from "./move_card"

export default function NeighborChip({ idea }: { idea: Idea }) {
  const label =
    idea.title ||
    previewFromHtml(idea.content, 100) ||
    idea.memo ||
    "Untitled"

  return (
    <div className="group/chip relative shrink-0">
      <IdeaBox idea={idea} shadow={false} />
      <div
        role="tooltip"
        className={classNames(
          "pointer-events-none absolute bottom-full left-1/2 z-30 mb-2 w-max max-w-[14rem]",
          "-translate-x-1/2 px-2.5 py-1.5",
          "rounded-lg bg-gray-900/95 text-[12px] font-medium leading-snug text-white shadow-lg",
          "opacity-0 transition-opacity duration-150",
          "group-hover/chip:opacity-100",
          "dark:bg-gray-100 dark:text-gray-900",
        )}
      >
        <span className="line-clamp-3">{label}</span>
        {/* caret */}
        <span
          className="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 border-x-4 border-t-4 border-x-transparent border-t-gray-900/95 dark:border-t-gray-100"
          aria-hidden
        />
      </div>
    </div>
  )
}
